module.exports = __webpack_public_path__ + "media/categorise.219f1e03.webm";